import api, { getParams } from './'

const financeEndpoints = {
  DEV_resetCorporateCustomer: () => api.post(`finance/corporate/onboarding/reset`),
  DEV_verificationTest: (id, data) => api.post(`finance/item_verification_test/${id}`, data),
  DEV_resetPlaidLogin: (id, data) => api.post(`finance/reset_login_test/${id}`, data),
  boostAccount: data => api.post(`finance/money/move`, data),
  makeTransaction: data => api.post(`finance/money/transact`, data),
  makeCorporateTransaction: data => api.post(`finance/corporate/money/move`, data),
  getCorporateOnboarding: () => api.get(`finance/corporate/onboarding`),
  setCorporateOnboarding: data => api.post(`finance/corporate/onboarding`, data),
  getCorporateOnboardingDocuments: () => api.get(`finance/corporate/onboarding/documents`),
  createPlaidLinkToken: (data, isCorporate) => api.post(`finance${isCorporate ? `/corporate` : ''}/create_link_token`, data),
  relinkPlaid: (isCorporate, connected_account_id) => api.post(`finance${isCorporate ? `/corporate` : ''}/create_link_token`, { update: true, connected_account_id }),
  getPlaidAccessToken: (data, isCorporate) => api.post(`finance${isCorporate ? `/corporate` : ''}/get_access_token`, data),
  clearPlaidStatus: (isCorporate, account_id) => api.post(`finance${isCorporate ? `/corporate` : ''}/link_update`, { account_id }),
  setCorporateOnboardingDocuments: data => {
    let formData = new FormData()
    formData.append('file', data.file)
    formData.append('document_type', data.document_type)
    formData.append('tags', 'codeinfuse, medium, gist')
    formData.append('upload_preset', 'pvhilzh7')
    return api.post(`finance/corporate/onboarding/documents`, formData)
  },
  createBeneficialOwner: data => api.post(`finance/corporate/onboarding/beneficial_owner`, data),
  updateBeneficialOwner: data => api.post(`finance/corporate/onboarding/beneficial_owner/detail`, data),
  getBeneficialOwners: () => api.get(`finance/corporate/onboarding/beneficial_owners`),
  deleteBeneficialOwner: data => api.post(`finance/corporate/onboarding/beneficial_owner/delete`, data),
  certifyBeneficialOwners: () => api.post(`finance/corporate/onboarding/beneficial_owner/certify`),
  getCorporateExternalAccounts: () => api.get(`finance/corporate/external/accounts`),
  deleteCorporateExternalAccount: id => api.delete(`finance/corporate/external/accounts/${id}`),
  getBusinessClassifications: () => api.get(`finance/corporate/list_business_classifications`),
  getCorporateOnboardingStatus: () => api.get(`finance/corporate/onboarding/status`),
  getCorporateDocumentStatus: doc_id => api.post(`finance/corporate/onboarding/document/status`, { doc_id }),
  getAuthorizationText: () => api.get(`finance/ondemand_authorization_text`),
  completeAccount: (isCorporate, id) => api.post(`finance/${isCorporate ? 'corporate/' : ''}complete_account/${id}`),
  getCorporateTransactionHistory: (month, year, page, page_size) => api.get(`finance/corporate/transaction/history${getParams({ month, year, page, page_size })}`),
  getCorporateWalletHistory: (month, year, page, page_size) => api.get(`finance/corporate/transaction/wallet/history${getParams({ month, year, page, page_size })}`),
  cancelCorporateTransaction: id => api.put(`finance/corporate/money/transaction/${id}/cancel`),
  setBeneficialOwnerDocuments: data => {
    let formData = new FormData()
    formData.append('file', data.file)
    formData.append('document_type', data.document_type)
    formData.append('bo_id', data.bo_id)
    formData.append('tags', 'codeinfuse, medium, gist')
    formData.append('upload_preset', 'pvhilzh7')
    return api.post(
      `finance/corporate/onboarding/beneficial_owner/documents`,
      formData
    )
  },
  getBeneficialOwnerStatus: () => api.get(`finance/corporate/onboarding/beneficial_ownership/status`),
  getBeneficialOwnerDetails: data => api.post(`finance/corporate/onboarding/beneficial_owner/detail`, data),
  makeBulkCorporateTransaction: data => api.post(`finance/corporate/money/move/bulk`, data),
  getBulkEmployeeRewardAttempts: () => api.get(`finance/corporate/money/move/bulk`),
  emailCorporateTransactionHistory: (fromDate, toDate) => api.get(`finance/corporate/transaction/history/download?from_date=${fromDate}&to_date=${toDate}`),
  getAllBudgets: () => api.get(`finance/corporate/budgets?all=true`),
  getMyBudgets: () => api.get(`finance/corporate/budgets`),
  updateBudget: (budget_id, data) => api.put(`finance/corporate/budget/${budget_id}`, data),
  getBudget: (budget_id, changes) => api.get(`finance/corporate/budget/${budget_id}${changes ? '?changes=true' : ''}`),
  createBudget: data => api.post(`finance/corporate/budget`, data),
  createBulkBudget: data => api.post(`finance/corporate/budget/bulk`, data),
  deleteBudget: budget_id => api.delete(`finance/corporate/budget/${budget_id}`),
  getManagerDetails: () => api.get(`finance/corporate/budgets/manager`),
  rewardManagerToEmployee: data => api.post(`finance/corporate/money/move/peer`, data),
  bulkRewardManagerToEmployee: data => api.post(`finance/corporate/money/move/peer/bulk`, data),
  requestAdditionalBudget: (budget_id, data) => api.post(`finance/corporate/budget/${budget_id}/request`, data),
  requestBudget: data => api.post(`finance/corporate/budget/request`, data),
  getRewardLog: () => api.get(`finance/corporate/money/move/bulk`),
  getBookingStats: num_of_months => api.get(`finance/corporate/stats/booking${getParams({ num_of_months })}`), // 3;6;9;12
  getBudgetStats: () => api.get(`finance/corporate/stats/budgets`),
  getEmployeeStats: () => api.get(`finance/corporate/stats/employees`),
  getFundingStats: () => api.get(`finance/corporate/stats/funding`),
  getPayrollAccessToken: () => api.post(`finance/payroll/get_access_token`),
  requestAdminPayrollDisconnect: () => api.post(`finance/payroll/request`),
  createKYBBusiness: legal_business_name => api.post(`finance/corporate/onboarding/business`, { legal_business_name }),
  getKYBInquiryID: () => api.get(`finance/corporate/onboarding/business/kyb`),
  setKYBUnderReview: () => api.get(`finance/corporate/onboarding/business/kyb/datacomplete`),
  getCorporateStatementPDF: (month, year) => api.get(`finance/corporate/transaction/statement${getParams({ month, year, pdf: true })}`),
  getCorporateStatement: (month, year) => api.get(`finance/corporate/transaction/statement${getParams({ month, year })}`),
  getCorporateExternalCard: () => api.get(`finance/corporate/external/cards`),
  removeCorporateExternalCard: unique_id => api.delete(`finance/corporate/external/cards/${unique_id}`),
  purchaseCompanyPoints: data => api.post(`finance/corporate/transaction/points/purchase`, data),
  getCorporatePointsHistory: (month, year, page, page_size) => api.get(`finance/corporate/transaction/points/history${getParams({ month, year, page, page_size })}`),
  getRewardBadges: () => api.get(`finance/corporate/rewards/badges`),
}

export default financeEndpoints